import ToastContent from "@components_system/Shared/Tools/Toast/ToastContent";

const ToastOptions = {
  transition: "Vue-Toastification__fade",
  maxToasts: 12,
  newestOnTop: true,
  position: "top-right",
  timeout: 4000,
  pauseOnFocusLoss: true,
  pauseOnHover: false,
  draggable: true,
  draggablePercent: 2,
  hideProgressBar: true,
  showCloseButtonOnHover: true,
  closeButton: "button",
  closeOnClick: false,
  rtl: false,
  toastDefaults: {
    'info': {
      icon: "fas fa-exclamation-circle",
    },
    'success': {
      icon: "fas fa-check-circle",
    },
    'error': {
      icon: "fas fa-times-circle",
    },  
  },
  filterBeforeCreate: (toast) => {
    if (
      toast.content === null || 
      toast.content === undefined || 
      typeof toast.content === 'string' ||
      (
        typeof toast.content === 'object' && 
        toast.content &&
        (toast.content.message || toast.content.title)
      )
    ) {
      toast.content = {
        component: ToastContent,
        props: {
          type: toast.type,
          title: toast.content && toast.content.title,
          message: (toast.content && toast.content.message) || toast.content,
        },
      };
    }

    return toast;
  },
}

export default { ToastOptions };
export { ToastOptions };